module.exports = __webpack_public_path__ + "static/artboard1-3795396b1abaebf86eb642736e5314ad.png";